import { trackEvent } from "../lib/tracking";

// Official social profiles — identity links only (never embedded feeds).
// Hand-drawn inline SVGs: zero third-party weight, instantly recognizable
// platform geometry, styled in the site's own palette.
const InstagramIcon = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2.6" y="2.6" width="18.8" height="18.8" rx="5.4" />
    <circle cx="12" cy="12" r="4.1" />
    <circle cx="17.35" cy="6.65" r="0.7" fill="currentColor" stroke="none" />
  </svg>
);

const FacebookIcon = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const TikTokIcon = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

const SOCIALS = [
  {
    platform: "instagram",
    label: "Instagram",
    href: "https://www.instagram.com/thenurturedparentcollective",
    Icon: InstagramIcon,
  },
  {
    platform: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/share/14vaVd9jAbT/",
    Icon: FacebookIcon,
  },
  {
    platform: "tiktok",
    label: "TikTok",
    href: "https://www.tiktok.com/@thenurturedparentco",
    Icon: TikTokIcon,
  },
];

// variant: "dark" (ink footer) or "light" (bio sections). 44px touch targets,
// subtle lift on hover, full keyboard focus ring, engagement-only tracking.
export const SocialLinks = ({ location, variant = "light", size = 19, className = "" }) => {
  const dark = variant === "dark";
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {SOCIALS.map(({ platform, label, href, Icon }) => (
        <a
          key={platform}
          data-testid={`social-link-${platform}-${location}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Follow The Nurtured Parent Co. on ${label}`}
          onClick={() =>
            trackEvent("social_link_click", {
              social_platform: platform,
              social_link_location: location,
            })
          }
          className={`flex items-center justify-center w-11 h-11 rounded-full transition-[color,background-color,transform] duration-300 hover:-translate-y-0.5 focus-visible:outline-2 focus-visible:outline-offset-2 ${
            dark
              ? "text-ivory/50 hover:text-ivory hover:bg-ivory/10 focus-visible:outline-ivory/60"
              : "text-smoke hover:text-ink hover:bg-ink/5 focus-visible:outline-ink/40"
          }`}
        >
          <Icon size={size} />
        </a>
      ))}
    </div>
  );
};
